import { Alert, Box, Grid, Skeleton, Stack } from '@mui/material';
import { useLogbookOptions } from '../hooks/useLogbookOptions';
import { useLogbookTemplateDetails } from '../hooks/useLogbookTemplateDetails';
import { LogbookTemplateEditData } from '../types/loogBookTypes';
import LogbookTemplateForm from './LogbookTemplateForm';
import Button from '../../../core-components/theme/components/Button/Button';

function LogbookTemplateFormSkeleton() {
    return (
        <Grid width='100% !important' container spacing={{ xs: 2, md: 3 }} sx={{ p: 3 }}>
            <Grid item xs={12}><Skeleton variant="rectangular" height={56} /></Grid>
            <Grid item xs={12}><Skeleton variant="rectangular" height={56} /></Grid>
            <Grid item xs={12} md={6}><Skeleton variant="rectangular" height={56} /></Grid>
            <Grid item xs={12} md={6}><Skeleton variant="rectangular" height={56} /></Grid>
            <Grid item xs={12}><Skeleton variant="rectangular" width="100%" height={300} /></Grid>
        </Grid>
    );
}

interface LogbookTemplateModalContentProps {
    onClose: () => void;
    initialData?: LogbookTemplateEditData;
}

export default function LogbookTemplateModalContent({ onClose, initialData }: LogbookTemplateModalContentProps) {
    const { data: optionsData, isLoading: optionsLoading, isError: isOptionsError } = useLogbookOptions(true);
    const { data: templateDetails, isLoading: isTemplateLoading, isError: isTemplateError } = useLogbookTemplateDetails(initialData?.logbookTemplateId);

    if (isTemplateLoading && !!initialData?.logbookTemplateId) {
        return <LogbookTemplateFormSkeleton />;
    }

    if (isTemplateError || isOptionsError) {
        return <Stack height='100%' direction='column' justifyContent='space-between'>
            <Alert severity="error" >Failed to load required data. Please close and try again.</Alert>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, pt: 2 }}>
                <Button
                    variant='outlined'
                    onClick={onClose}
                >
                    Cancel
                </Button>
            </Box>
        </Stack>
            ;
    }

    const types = optionsData?.types ?? [];
    const categories = optionsData?.categories ?? [];

    return (
        <LogbookTemplateForm
            onClose={onClose}
            initialData={templateDetails}
            selectOptions={{ types, categories }}
            optionsStatus={{ loading: optionsLoading, error: isOptionsError }}
        />
    );
}
